import { ClientDetails } from '@models/app-data'
import { ClientDetailsActionTypesKeys, SetClientDetailsAction } from '@store/action-types/client-details-action-types'

export function setClientDetails(payload: ClientDetails): SetClientDetailsAction {
  return { type: ClientDetailsActionTypesKeys.SET_CLIENT_DETAILS, payload }
}
